import { render, staticRenderFns } from "./TimeDiscount.vue?vue&type=template&id=30c3b384&"
import script from "./TimeDiscount.vue?vue&type=script&lang=js&"
export * from "./TimeDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TimeDiscount.vue?vue&type=style&index=0&id=30c3b384&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports